export default "__VITE_ASSET__DgA3zTgm__"